var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = (function() {
	(function() {
		$('.hslider').slick({
			prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-slider-prev"></i></button>',
			nextArrow: '<button type="button" class="slick-next"><i class="icon icon-slider-next"></i></button>',
			dots: false,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 7000,
			speed: 1500,
			responsive: [
			    {
			      breakpoint: 768,
			      settings: {
			        dots: true,
			        arrows: false
			      }
			    },
			]
		});
	})();
})();
